module.exports = __webpack_public_path__ + "img/logo18.3b5a07ee.jpg";